/**
 * 登入後要去哪裡（v2.61.0）
 *
 * 後臺的登入憑證存在 sessionStorage（每個分頁各一份），從 LINE / Discord 點連結開的新分頁
 * 一定還沒登入 → 先到登入頁。要讓「登入完回到原本要去的地方」，就在導去登入頁之前記下來。
 *
 * 🔑 只接受白名單裡的站內路徑 —— 不能變成「帶任意網址、登入後幫你導過去」的跳板。
 * 目前只有 `/partner`（分享給同事的「合作夥伴專區」入口）。
 */
const KEY = "post_login_redirect";
const ALLOWED = ["/partner"];

export function rememberPostLogin(path) {
  if (!ALLOWED.includes(path)) return;
  try {
    sessionStorage.setItem(KEY, path);
  } catch (e) {
    /* 存不了就登入後回首頁 */
  }
}

/** 只讀不清：登入頁的 render 可能跑好幾次，每次都要拿到同一個答案；由目的地頁自己清 */
export function peekPostLogin() {
  try {
    const v = sessionStorage.getItem(KEY);
    return ALLOWED.includes(v) ? v : null;
  } catch (e) {
    return null;
  }
}

export function clearPostLogin() {
  try {
    sessionStorage.removeItem(KEY);
  } catch (e) {
    /* 沒差 */
  }
}
